module.exports = __webpack_public_path__ + "img/sms.7dd25f75.svg";